// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"48":"a0546e6ef36e82e4","991":"227cf772a3935760","1441":"cbc5936f08461d75","2024":"3793ec5044ccda62","4456":"c92d3b743144863b","9896":"2cf6a8246b76a54b"}[chunkId] + ".css";
};